import confetti from "canvas-confetti";

const colors = ["#A855F7", "#C084FC", "#E9D5FF", "#F0ABFC", "#7C3AED", "#FFFFFF"];

export const fireConfetti = () => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const base = { particleCount: 90, spread: 70, startVelocity: 55, colors, zIndex: 9999, ticks: 220 };
  confetti({ ...base, angle: 60, origin: { x: 0, y: 0.75 } });
  confetti({ ...base, angle: 120, origin: { x: 1, y: 0.75 } });
  setTimeout(() => confetti({ ...base, particleCount: 120, spread: 110, origin: { x: 0.5, y: 0.35 } }), 250);
};
